import React, { Fragment, useState, useEffect } from "react";
import PortalMenu from "../Common/PortalMenu";
import AppPagination from "../Common/AppPagination";
import { Row, Col, Card, Dropdown, Modal, Button, Table, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import swal from "sweetalert";
import SignatureModal from "../Common/SignatureModal";
import { useSelector } from "react-redux";
import PermissionWrapper from "../PermissionWrapper";

const TestCertificatesList = () => {
 const user = useSelector((state) => state.auth?.userDetails || {});
 const [certificates,setCertificates] = useState([]);
const [selectedCertificate,setSelectedCertificate] = useState(null);
const [showModal,setShowModal] = useState(false);
const [loading,setLoading] = useState(false);
const [previewingPdf,setPreviewingPdf] = useState(false);
const [showSignModal, setShowSignModal] = useState(false);
const [approveId, setApproveId] = useState(null);

const [pagination,setPagination] = useState({
currentPage:1,
limit:10,
totalPages:1,
totalCount:0
});


useEffect(()=>{
fetchCertificates();
},[pagination.currentPage]);


/* ================= FETCH ================= */

const fetchCertificates = async () => {

try{

setLoading(true);

const res = await api.get("/test-certificates",{
params:{
page:pagination.currentPage,
limit:pagination.limit
}
});

if(res.data.success){

setCertificates(res.data.data || []);

if(res.data.pagination){

setPagination(prev=>({
...prev,
totalPages:res.data.pagination.totalPages,
totalCount:res.data.pagination.totalCount
}));

}

}

}catch(err){

console.error(err);
swal("Error","Failed to load certificates","error");

}finally{

setLoading(false);

}

};



const handlePageChange = (page) => {
 setPagination(prev => ({ ...prev, currentPage: page }));
};

/* ================= PDF DOWNLOAD ================= */

const handleDownloadPDF = async(id)=>{

try{

const res = await api.get(`/test-certificates/${id}/pdf`,{
responseType:"blob"
});

const url = window.URL.createObjectURL(new Blob([res.data]));

const link = document.createElement("a");

link.href = url;
link.download = `TEST-CERT-${id}.pdf`;

document.body.appendChild(link);
link.click();
link.remove();

}catch(err){

swal("Error","Failed to download PDF","error");

}

};



/* ================= PDF PREVIEW ================= */

const handlePreviewPDF = async(id)=>{

try{

setPreviewingPdf(true);

const res = await api.get(`/test-certificates/${id}/pdf`,{
responseType:"blob"
});

const fileURL = window.URL.createObjectURL(
new Blob([res.data],{type:"application/pdf"})
);

window.open(fileURL,"_blank");

}catch(err){

console.error(err);
swal("Error","Failed to preview PDF","error");

}finally{

setPreviewingPdf(false);

}

};



/* ================= DELETE ================= */

const handleDelete = async(id)=>{

const confirm = await swal({
title:"Delete certificate?",
text:"This action cannot be undone",
icon:"warning",
buttons:["Cancel","Delete"],
dangerMode:true
});

if(!confirm) return;

try{

await api.delete(`/test-certificates/${id}`);

swal("Deleted","Certificate deleted successfully","success");

fetchCertificates();

}catch(err){

swal("Error","Failed to delete certificate","error");

}

};



/* ================= VIEW ================= */

const handleView = async(id)=>{

try{

const res = await api.get(`/test-certificates/${id}`);

if(res.data.success){

setSelectedCertificate(res.data.data);
setShowModal(true);

}

}catch(err){

swal("Error","Failed to load certificate","error");

}

};

/* ================= APPROVE / REJECT ================= */

const handleApprove = async (id) => {
 const confirm = await swal({
 title: "Approve Certificate?",
 text: "Signature is required for approval.",
 icon: "info",
 buttons: ["Cancel", "Provide Signature"],
 });

 if (!confirm) return;

 setApproveId(id);
 setShowSignModal(true);
};

const handleSaveSignature = async (file) => {
 try {
 setLoading(true);

 const formData = new FormData();
 formData.append("signature", file);

 const res = await api.patch(`/test-certificates/${approveId}/approve`, formData, {
 headers: {
 "Content-Type": "multipart/form-data",
 },
 });

 if (res.data.success) {
 swal("Approved!", "Certificate approved successfully", "success");
 setShowSignModal(false);
 setApproveId(null);
 fetchCertificates();
 }
 } catch (err) {
 swal(
 "Error",
 err.response?.data?.message || "Failed to approve certificate",
 "error",
 );
 } finally {
 setLoading(false);
 }
};

const handleReject = async (id) => {
 const remarks = prompt("Enter rejection reason:");
 if (!remarks) return;

 try {
 const res = await api.patch(`/test-certificates/${id}/reject`, { remarks });
 if (res.data.success) {
 swal("Rejected!", "Certificate rejected", "success");
 fetchCertificates();
 }
 } catch (err) {
 swal("Error", "Failed to reject", "error");
 }
};



/* ================= HELPERS ================= */

const formatDate = (date)=>{

if(!date) return "-";

return new Date(date).toLocaleDateString("en-IN",{
day:"2-digit",
month:"short",
year:"numeric"
});

};


const renderProducts = (items)=>{

if(!items || items.length===0) return "-";

return (

<ul className="mb-0 ps-3 small">

{items.slice(0,3).map((it,idx)=>{

const name =
it.product?.productName ||
it.productName ||
"-";

const model =
it.product?.modelNo ||
it.modelNo ||
"";

return(

<li key={idx}>
<strong>{name}</strong>
{model && ` (${model})`} — {it.qty}
</li>

);

})}

{items.length>3 && (
<li className="text-muted">
+{items.length-3} more
</li>
)}

</ul>

);

};


const svgMenu = (
<svg width="20" height="20" viewBox="0 0 24 24">
<circle cx="5" cy="12" r="2"></circle>
<circle cx="12" cy="12" r="2"></circle>
<circle cx="19" cy="12" r="2"></circle>
</svg>
);



/* ================= UI ================= */

return(

<Fragment>

<PageTitle activeMenu="Test Certificates" motherMenu="Quality" />

<Row>

<Col lg={12}>

<Card>

<Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title>Test Certificate List</Card.Title>
 <PermissionWrapper user={user} required={["create:tcs"]}>
 <Link to="/test-certificates/add" className="btn btn-success">
 + Add Certificate
 </Link>
 </PermissionWrapper>
 </Card.Header>


<Card.Body>

{loading ? (

<div className="text-center py-5">
<div className="spinner-border text-primary"></div>
<p className="mt-2">Loading certificates...</p>
</div>

) : certificates.length===0 ? (

<div className="text-center py-5">
<p>No certificates found</p>

<Link to="/test-certificates/add" className="btn btn-primary">
+ Add Certificate
</Link>

</div>

) : (

<div className="table-responsive" style={{ overflow: "visible" }}>

<Table hover bordered className="align-middle">

<thead style={{ backgroundColor: "#ffd0a7" }}>

<tr>

<th>#</th>
<th>Client</th>
<th>Subject</th>
<th style={{minWidth:"260px"}}>Products</th>
<th>Status</th>
<th>Date</th>
<th>Actions</th>
</tr>
</thead>
<tbody>
{certificates.map((cert,i)=>(
<tr key={cert._id}>
<td>
{(pagination.currentPage-1)*pagination.limit+(i+1)}
</td>
<td>
<strong>{cert.client || "-"}</strong>
</td>
<td>{cert.subject || "-"}</td>
<td>{renderProducts(cert.items)}</td>
<td>
 <Badge bg={cert.status === "Approved" ? "success" : cert.status === "Rejected" ? "danger" : "warning"}>
 {cert.status || "Draft"}
 </Badge>
</td>
<td>{formatDate(cert.certificateDate)}</td>
<td>
<Dropdown>
<Dropdown.Toggle
variant=""
as="div"
className="btn i-false p-0 cursor-pointer"
>
{svgMenu}
</Dropdown.Toggle>
<Dropdown.Menu align="end" as={PortalMenu}>
<PermissionWrapper user={user} required={["read:tcs"]}>
 <Dropdown.Item onClick={()=>handleView(cert._id)}>
 <i className="fas fa-eye me-2"></i>
 View
 </Dropdown.Item>
</PermissionWrapper>

{cert.status !== "Approved" && (
 <PermissionWrapper user={user} required={["edit:tcs"]}>
 <Dropdown.Item
 as={Link}
 to={`/test-certificates/edit/${cert._id}`}
 >
 <i className="fas fa-edit me-2"></i>
 Edit
 </Dropdown.Item>
 </PermissionWrapper>
)}

<PermissionWrapper user={user} required={["read:tcs"]}>
 <Dropdown.Item
 onClick={()=>handlePreviewPDF(cert._id)}
 disabled={previewingPdf}
 >
 <i className="fas fa-eye me-2 text-primary"></i>
 Preview PDF
 </Dropdown.Item>
 <Dropdown.Item
 onClick={()=>handleDownloadPDF(cert._id)}
 >
 <i className="fas fa-file-pdf me-2 text-danger"></i>
 Download PDF
 </Dropdown.Item>
</PermissionWrapper>

{(cert.status === "Draft" || cert.status === "Pending") && (
 <>
 <Dropdown.Divider />
 <PermissionWrapper user={user} required={["approve:tcs"]}>
 <Dropdown.Item
 onClick={() => handleApprove(cert._id)}
 className="text-success"
 >
 <i className="fas fa-check me-2"></i>Approve
 </Dropdown.Item>
 </PermissionWrapper>
 <PermissionWrapper user={user} required={["reject:tcs"]}>
 <Dropdown.Item
 onClick={() => handleReject(cert._id)}
 className="text-danger"
 >
 <i className="fas fa-times me-2"></i>Reject
 </Dropdown.Item>
 </PermissionWrapper>
 </>
)}

<Dropdown.Divider/>
<PermissionWrapper user={user} required={["delete:tcs"]}>
 <Dropdown.Item
 className="text-danger"
 onClick={()=>handleDelete(cert._id)}
 >
 <i className="fas fa-trash me-2"></i>
 Delete
 </Dropdown.Item>
</PermissionWrapper>
</Dropdown.Menu>
</Dropdown></td></tr>))}</tbody></Table>

{/* Signature Modal */}
<SignatureModal
 show={showSignModal}
 onHide={() => {
 setShowSignModal(false);
 setApproveId(null);
 }}
 onSave={handleSaveSignature}
 title="Client Signature for TC Approval"
/>

{/* Pagination */}
<AppPagination
 currentPage={pagination.currentPage}
 totalPages={pagination.totalPages}
 totalCount={pagination.totalCount}
 itemsLength={certificates.length}
 limit={pagination.limit}
 onPageChange={handlePageChange}
 />

</div>

)}

</Card.Body>

</Card>

</Col>

</Row>


{/* ================= MODAL ================= */}

<Modal
show={showModal}
onHide={()=>setShowModal(false)}
size="lg"
centered
>

<Modal.Header closeButton>
<Modal.Title>Certificate Details</Modal.Title>
</Modal.Header>

<Modal.Body>

{selectedCertificate && (

<>

<p>
<strong>Client:</strong> {selectedCertificate.client || "-"}
</p>

<p>
<strong>Subject:</strong> {selectedCertificate.subject}
</p>

<hr/>

<Table bordered responsive>

<thead className="table-light">

<tr>
<th>#</th>
<th>Product</th>
<th>Model</th>
<th>Qty</th>
<th>Serial From</th>
<th>Serial To</th>
</tr>

</thead>

<tbody>

{selectedCertificate.items?.map((it,i)=>{

const name =
it.product?.productName ||
it.productName ||
"-";

const model =
it.product?.modelNo ||
it.modelNo ||
"-";

return(

<tr key={i}>
<td>{i+1}</td>
<td>{name}</td>
<td>{model}</td>
<td>{it.qty}</td>
<td>{it.serialFrom}</td>
<td>{it.serialTo}</td>
</tr>

);

})}

</tbody>

</Table>

</>

)}

</Modal.Body>

<Modal.Footer>

<Button variant="secondary" onClick={()=>setShowModal(false)}>
Close
</Button>

{selectedCertificate && (

<>
<Button
variant="danger"
onClick={()=>handleDownloadPDF(selectedCertificate._id)}
>
<i className="fas fa-file-pdf me-2"></i>
Download PDF
</Button>

<Link
to={`/test-certificates/edit/${selectedCertificate._id}`}
className="btn btn-primary"
>
Edit Certificate
</Link>
</>

)}

</Modal.Footer>

</Modal>


{/* ================= PDF PREVIEW LOADER ================= */}

{previewingPdf && (

<div
className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
style={{
background:"rgba(0,0,0,0.4)",
zIndex:9999
}}
>

<div className="bg-white p-4 rounded shadow text-center">

<div className="spinner-border text-primary mb-3"></div>

<h6 className="mb-0">Preparing Certificate PDF…</h6>

</div>

</div>

)}

</Fragment>

);

};

export default TestCertificatesList;
